













import { Vue, Component, Prop } from "vue-property-decorator";
@Component
export default class NoteRichiestaDialog extends Vue{
    @Prop() info!: any;

    private dialog: boolean;

    constructor() {
        super();
        this.dialog = false;
    }
}
